import React, { PropsWithChildren } from 'react';
import c from 'classnames';
import { CommonFacetAPI } from '../../common';
import s from './FacetContent.scss';

export interface Props extends Pick<CommonFacetAPI, 'size'> {
  className?: string;
}

const FacetContent: React.FC<PropsWithChildren<Props>> = ({
  size,
  className,
  children,
}) => {
  return <div className={c(s[`size-${size}`], className)}>{children}</div>;
};

FacetContent.displayName = 'FacetContent';

export default FacetContent;
